import React from 'react';
import './style.scss';
import ProductPlateItemPrice from '../ProductsList/PlateItem/Price';
import {bindActionCreators, compose} from 'redux';
import * as productsActions from '../../actions/productsActionCreators';
import * as cartActions from '../../actions/cartActionCreators';
import {Link} from 'react-router-dom';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {connect} from 'react-redux';
import Button from '../Button';
import constants from '../../constants';
import {fetchComparisonOffers} from '../../actions/productsActionCreators';

const ComparisonTable = ({offers, traits, ...props}) => {
  const
    inCartProducts = Object.keys(props.cartState.info?.products || {}),
    handleAddToCart = (offerId) => () => {
      props.cartActions.addToCart(offerId);
    },
    handleRemove = (offerId) => () => {
      props.productsActions.removeOfferFromComparison(offerId);
      props.productsActions.fetchComparisonOffers();
    },
    city_slug = props.applicationState.current_city.slug,
    ssr = props.railsContext.serverSide;

  if (!offers.length) {
    return (
      <div style={{minHeight: 400}}>
        <h2>
          <div>
            Вы не добавили товары в сравнение, сделайте это в
            <Link className='link' to={constants.ROUTES.REGIONAL_CATALOGUE_PATH(city_slug)}> каталоге</Link>
          </div>
        </h2>
      </div>
    );
  }

  return (
    <div className="product-comparison--main-wrapper">
      <div className="product-comparison--table-wrapper" id="js-product-comparison-output">
        <table className="product-comparison--table">
          <thead className="product-comparison--head">
            <tr className="product-comparison--head-row product-comparison--head-row_top">
              {
                offers.map(offer => {
                  const path = constants.ROUTES.REGIONAL_PRODUCT_PATH(city_slug, offer.rubric_path, offer.id_with_slug)
                  return (
                    <th className="product-comparison--head-cell">
                      <div className="product-item comparison-">
                        <div className="labels-block">
                        </div>
                        <div className="top-actions">
                          <button className="remove-" onClick={handleRemove(offer.id)}>Удалить</button>
                        </div>
                        <div className="product-item-top">
                          <Link itemProp="url" to={path} className='products-list-item__image'>
                            { offer.image ?
                              (props.ssr ?
                                  <img itemProp="image" src={offer.image.big_image_url} alt={offer.image.alt || offer.name} />
                                  : <LazyLoadImage src={offer.image.big_image_url} alt={offer.image.alt || offer.name} />
                              )
                              : null}
                            <div className='products-list-item__image-bg' />
                          </Link>
                        </div>
                        <div className="product-item-bottom">
                          <Link
                            className="title link"
                            to={path}
                          >
                            {offer.name}
                          </Link>
                        </div>
                      </div>
                    </th>
                  );
                })

              }
            </tr>
            <tr className="product-comparison--head-row">
              {
                offers.map(offer => {
                  return (
                    <th className="product-comparison--head-cell">
                      <div className="product-item comparison-">
                        <div className="product-item-bottom">
                          <div className="price-box">
                            <div className="price-box-right">
                              <div className="price">
                                <ProductPlateItemPrice offer={offer} />
                              </div>
                              {
                                inCartProducts.includes('' + offer.product_id) ?
                                  <Button primary to={constants.ROUTES.CART} className='sm'>Добавлен</Button>
                                  : <Button
                                    onClick={handleAddToCart(offer.id)}
                                    primary
                                    className='sm'
                                    loader={!!props.cartState.addingToCartOfferIds.includes(offer.id)}
                                  >В корзину</Button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </th>
                  );
                })
              }
            </tr>
          </thead>
          <tbody className="product-comparison--body">
            {
              traits.map(trait => {
                return (
                  <>
                    <tr className="product-comparison--trait-title">
                      <td colSpan={offers.length}>{trait.title}</td>
                    </tr>
                    <tr className="product-comparison--trait-value-row">
                      {
                        offers.map(offer => {
                          const traitValue = offer.indexed_traits[trait.id];
                          return (
                            <td className="product-comparison--trait-value-cell" key={offer.id}>
                              {
                                traitValue ?
                                  traitValue[1]
                                  : <span className="empty">нет данных</span>
                              }
                            </td>
                          )
                        })
                      }
                    </tr>
                  </>
                );
              })
            }
          </tbody>
        </table>
      </div>
      <div className="scroll-arrow right- js-comparison-scroll-right"></div>
      <div className="scroll-arrow left- js-comparison-scroll-left disabled"></div>
    </div>
  );
}

const
  mapDispatchToProps = (dispatch) => {
    return {
      productsActions: bindActionCreators(productsActions, dispatch),
      cartActions: bindActionCreators(cartActions, dispatch),
    };
  },
  mapStateToProps = ({applicationState, cartState, railsContext}) => {
    return {
      railsContext,
      applicationState,
      cartState
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default compose(withConnect)(ComparisonTable);

